export default __webpack_public_path__ + "images/AL.14d507e.png";